import { call, select } from 'redux-saga/effects';
import { selectLocalUser } from 'features/users/usersSlice';
import { PermissionTypes } from 'features/permissions/types';
import { User } from 'features/users/types';
import { lookupDynamicPermission } from 'features/permissions/utils/lookupDynamicPermission';
import { HasDynamicPermissionsOptions } from 'features/permissions/utils/checkPermissions';

export function* hasDynamicPermissionsSaga(
  permission: PermissionTypes | PermissionTypes[],
  options: HasDynamicPermissionsOptions = {}
) {
  const { targetUser, mode = 'any' } = options;

  const localUser: User | undefined = yield select(selectLocalUser);

  const dynamicPermissions = targetUser
    ? targetUser.dynamicPermissions
    : localUser?.dynamicPermissions;

  const granted: boolean = yield call(lookupDynamicPermission, {
    permission,
    dynamicPermissions,
    mode,
  });

  return granted;
}
